export var ALL_WEEKDAYS = [
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
];
/**
 * Compile-time guard so a value added to PeriodicalFrequency cannot silently fall through the
 * mirrors below into MANUAL / zero fields — the switches must list every constant.
 */
export function assertNeverFrequency(value) {
    throw new Error("Unhandled periodical frequency: ".concat(String(value)));
}
export function familyOf(frequency) {
    if (!frequency)
        return "MANUAL";
    // The switch keys off the enum's string values so an unhandled constant narrows to `never`.
    var key = frequency;
    switch (key) {
        case "DAILY":
        case "FOUR_WEEKLY":
        case "SEMIWEEKLY":
        case "THREE_WEEKLY":
            return "WEEKDAY_MASK";
        case "WEEKLY":
            return "WEEKDAY_SINGLE";
        case "BIWEEKLY":
            return "BIWEEKLY";
        case "MONTHLY":
        case "SEMIMONTHLY":
        case "THREE_MONTHLY":
            return "DAYS_OF_MONTH";
        case "BIMONTHLY":
            return "BIMONTHLY";
        case "ELEVEN_YEARLY":
        case "TEN_YEARLY":
        case "NINE_YEARLY":
        case "EIGHT_YEARLY":
        case "SEVEN_YEARLY":
        case "FIVE_YEARLY":
        case "QUARTERLY":
        case "THREE_YEARLY":
        case "SEMIANNUAL":
        case "ANNUAL":
            return "ANCHOR_DATES";
        case "BIENNIAL":
        case "TRIENNIAL":
        case "IRREGULAR":
        case "UNKNOWN":
            return "MANUAL";
        default:
            return assertNeverFrequency(key);
    }
}
export function expectedDayCountFor(frequency) {
    if (!frequency)
        return 0;
    var key = frequency;
    switch (key) {
        case "DAILY":
            return 6;
        case "FOUR_WEEKLY":
            return 4;
        case "SEMIWEEKLY":
            return 2;
        case "THREE_WEEKLY":
            return 3;
        case "WEEKLY":
        case "BIWEEKLY":
            return 1;
        case "MONTHLY":
            return 1;
        case "SEMIMONTHLY":
            return 2;
        case "THREE_MONTHLY":
            return 3;
        case "BIMONTHLY":
            return 1;
        case "ELEVEN_YEARLY":
            return 11;
        case "TEN_YEARLY":
            return 10;
        case "NINE_YEARLY":
            return 9;
        case "EIGHT_YEARLY":
            return 8;
        case "SEVEN_YEARLY":
            return 7;
        case "FIVE_YEARLY":
            return 5;
        case "QUARTERLY":
            return 4;
        case "THREE_YEARLY":
            return 3;
        case "SEMIANNUAL":
            return 2;
        case "ANNUAL":
            return 1;
        case "BIENNIAL":
        case "TRIENNIAL":
        case "IRREGULAR":
        case "UNKNOWN":
            return 0;
        default:
            return assertNeverFrequency(key);
    }
}
// Mirrors backend ScheduleDefaults.anchorDatesJson — month = round(k * 12 / count)
function evenlySpreadAnchorDates(count) {
    return Array.from({ length: count }, function (_, index) { return ({
        month: Math.round(((index + 1) * 12) / count),
        day: 15,
    }); });
}
export function defaultConfigFor(frequency) {
    var family = familyOf(frequency);
    switch (family) {
        case "WEEKDAY_MASK":
            if (frequency === "SEMIWEEKLY") {
                return { weekdays: ["MONDAY", "THURSDAY"] };
            }
            if (frequency === "FOUR_WEEKLY") {
                return { weekdays: ["MONDAY", "TUESDAY", "THURSDAY", "FRIDAY"] };
            }
            if (frequency === "THREE_WEEKLY") {
                return { weekdays: ["MONDAY", "WEDNESDAY", "FRIDAY"] };
            }
            return {
                weekdays: [
                    "MONDAY",
                    "TUESDAY",
                    "WEDNESDAY",
                    "THURSDAY",
                    "FRIDAY",
                    "SATURDAY",
                ],
            };
        case "WEEKDAY_SINGLE":
            return { weekday: "MONDAY" };
        case "BIWEEKLY":
            return { weekday: "MONDAY", weekParity: "ODD" };
        case "DAYS_OF_MONTH":
            if (frequency === "SEMIMONTHLY")
                return { days: [1, 15] };
            if (frequency === "THREE_MONTHLY")
                return { days: [1, 11, 21] };
            return { days: [15] };
        case "BIMONTHLY":
            return { dayOfMonth: 15, monthParity: "ODD" };
        case "ANCHOR_DATES":
            if (frequency === "ANNUAL") {
                return { dates: [{ month: 1, day: 15 }] };
            }
            return { dates: evenlySpreadAnchorDates(expectedDayCountFor(frequency)) };
        default:
            return null;
    }
}
